import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import centers from './modules/centers'
import companyInfo from './modules/company-info'
import passengers from './modules/passengers'
import vehicles from './modules/vehicles'
import grades from './modules/grades'
import quickMessages from './modules/quick-messages'

Vue.use(Vuex)

export default new Vuex.Store({
	actions: {
		reset({ dispatch }) {
			dispatch('centers/reset');
			dispatch('companyInfo/reset');
			dispatch('passengers/reset');
			dispatch('vehicles/reset');
			dispatch('grades/reset');
			dispatch('quickMessages/reset');
		}
	},
	modules: {
		auth,
		centers,
		companyInfo,
		passengers,
		vehicles,
		grades,
		quickMessages
	}
})
